import UserStats from '../../Models/UserStats';
import type { ReduxAction } from '@app/types';
import { AppState } from '@reducers/rootReducer';
import Occasion from '@support/Occasion';

export const selectUserStats = (state: AppState) => state.user.stats;
export const selectUserContactCount = (state: AppState) => state.user.stats.contacts;

const initialUserStatsState = new UserStats();

export function userStatsReducer(
  state: UserStats = initialUserStatsState,
  { type, payload }: ReduxAction,
) {
  switch (type) {
    case 'FETCH_USER_STATS_REQUESTED':
      return state.copyWith({ isFetching: true });

    case 'FETCH_USER_STATS_SUCCEEDED':
      return state.copyWith({
        ...payload.response,
        isFetching: false,
        updated: new Occasion(),
      });

    case 'FETCH_USER_CONTACT_COUNT_SUCCEEDED':
      return state.copyWith({ contacts: payload.response.count });

    case 'FETCH_USER_STATS_FAILED':
    default:
      return state;
  }
}
